import { render, staticRenderFns } from "./LayoutSidenav.vue?vue&type=template&id=3f81bd28&"
import script from "./LayoutSidenav.vue?vue&type=script&lang=js&"
export * from "./LayoutSidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f81bd28')) {
      api.createRecord('3f81bd28', component.options)
    } else {
      api.reload('3f81bd28', component.options)
    }
    module.hot.accept("./LayoutSidenav.vue?vue&type=template&id=3f81bd28&", function () {
      api.rerender('3f81bd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/layout/LayoutSidenav.vue"
export default component.exports